// Copyright (c) 2022 by Move Closer

import {
  ContainerColor, ContainerColumnGap,
  ContainerMargin,
  ContainerPadding, ContainerRowGap,
  ContainerWidth,
  ContainerZIndex
} from './Container.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const containerBackgroundColorRegistry: Record<string, string> = {
  [ContainerColor.Dark]: '--dark'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const containerColorRegistry: Record<string, string> = {
  [ContainerColor.Dark]: '',
  [ContainerColor.White]: '#fff'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const containerColumnGap: Record<string, string | null> = {
  [ContainerColumnGap.Large]: 'var(--grid-gap-large)',
  [ContainerColumnGap.None]: 'unset',
  [ContainerColumnGap.Unset]: null
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const containerMarginClassNameRegistry: Record<string, { bottom: string; top: string }> = {
  [ContainerMargin.None]: { bottom: 'mb-0', top: 'mt-0' },
  [ContainerMargin.Spacer1]: { bottom: 'mb-1', top: 'mt-1' },
  [ContainerMargin.Spacer1Negative]: { bottom: 'mb-n1', top: 'mt-n1' },
  [ContainerMargin.Spacer2]: { bottom: 'mb-2', top: 'mt-2' },
  [ContainerMargin.Spacer2Negative]: { bottom: 'mb-n2', top: 'mt-n2' },
  [ContainerMargin.Spacer3]: { bottom: 'mb-3', top: 'mt-3' },
  [ContainerMargin.Spacer3Negative]: { bottom: 'mb-n3', top: 'mt-n3' },
  [ContainerMargin.Spacer4]: { bottom: 'mb-4', top: 'mt-4' },
  [ContainerMargin.Spacer4Negative]: { bottom: 'mb-n4', top: 'mt-n4' },
  [ContainerMargin.Spacer5]: { bottom: 'mb-5', top: 'mt-5' },
  [ContainerMargin.Spacer5Negative]: { bottom: 'mb-n5', top: 'mt-n5' },
  [ContainerMargin.Spacer6]: { bottom: 'mb-6', top: 'mt-6' },
  [ContainerMargin.Spacer6Negative]: { bottom: 'mb-n6', top: 'mt-n6' },
  [ContainerMargin.Spacer7]: { bottom: 'mb-7', top: 'mt-7' },
  [ContainerMargin.Spacer7Negative]: { bottom: 'mb-n7', top: 'mt-n7' },
  [ContainerMargin.Spacer8]: { bottom: 'mb-8', top: 'mt-8' },
  [ContainerMargin.Spacer8Negative]: { bottom: 'mb-n8', top: 'mt-n8' },
  [ContainerMargin.Spacer9]: { bottom: 'mb-9', top: 'mt-9' },
  [ContainerMargin.Spacer9Negative]: { bottom: 'mb-n9', top: 'mt-n9' },
  [ContainerMargin.Spacer10]: { bottom: 'mb-10', top: 'mt-10' },
  [ContainerMargin.Spacer10Negative]: { bottom: 'mb-n10', top: 'mt-n10' },
  [ContainerMargin.Spacer11]: { bottom: 'mb-11', top: 'mt-11' },
  [ContainerMargin.Spacer11Negative]: { bottom: 'mb-n11', top: 'mt-n11' },
  [ContainerMargin.Spacer12]: { bottom: 'mb-12', top: 'mt-12' },
  [ContainerMargin.Spacer12Negative]: { bottom: 'mb-n12', top: 'mt-n12' },
  [ContainerMargin.Spacer13]: { bottom: 'mb-13', top: 'mt-13' },
  [ContainerMargin.Spacer13Negative]: { bottom: 'mb-n13', top: 'mt-n13' },
  [ContainerMargin.Unset]: { bottom: '', top: '' }
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const containerPaddingClassNameRegistry: Record<string, { bottom: string; top: string }> = {
  [ContainerPadding.None]: { bottom: 'pb-0', top: 'pt-0' },
  [ContainerPadding.Spacer1]: { bottom: 'pb-1', top: 'pt-1' },
  [ContainerPadding.Spacer2]: { bottom: 'pb-2', top: 'pt-2' },
  [ContainerPadding.Spacer3]: { bottom: 'pb-3', top: 'pt-3' },
  [ContainerPadding.Spacer4]: { bottom: 'pb-4', top: 'pt-4' },
  [ContainerPadding.Spacer5]: { bottom: 'pb-5', top: 'pt-5' },
  [ContainerPadding.Spacer6]: { bottom: 'pb-6', top: 'pt-6' },
  [ContainerPadding.Spacer7]: { bottom: 'pb-7', top: 'pt-7' },
  [ContainerPadding.Spacer8]: { bottom: 'pb-8', top: 'pt-8' },
  [ContainerPadding.Spacer9]: { bottom: 'pb-9', top: 'pt-9' },
  [ContainerPadding.Spacer10]: { bottom: 'pb-10', top: 'pt-10' },
  [ContainerPadding.Unset]: { bottom: '', top: '' }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const containerRowGap: Record<string, string | null> = {
  [ContainerRowGap.None]: 'unset',
  [ContainerRowGap.Spacer1]: '0.25rem',
  [ContainerRowGap.Spacer2]: '0.5rem',
  [ContainerRowGap.Spacer3]: '1rem',
  [ContainerRowGap.Spacer4]: '1.5rem',
  [ContainerRowGap.Spacer5]: '2rem',
  [ContainerRowGap.Spacer6]: '3rem',
  [ContainerRowGap.Spacer7]: '4rem',
  [ContainerRowGap.Spacer8]: '5rem',
  [ContainerRowGap.Spacer9]: '6rem',
  [ContainerRowGap.Spacer10]: '7rem',
  [ContainerRowGap.Unset]: null
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const containerWidthClassNameRegistry: Record<string, string> = {
  [ContainerWidth.Narrow]: 'container-narrow',
  [ContainerWidth.Normal]: 'container',
  [ContainerWidth.Wide]: 'container-wide'
}
/**
 * @author Piotr Niewczas <piotr.niewczas@movecloser.pl>
 */
export const containerZIndexClassNameRegistry: Record<string, string> = {
  [ContainerZIndex.ZIndexN1]: 'send-to-back',
  [ContainerZIndex.None]: 'reset-index',
  [ContainerZIndex.ZIndex1]: 'send-to-front',
  [ContainerZIndex.ZIndex10]: 'send-to-front-10',
  [ContainerZIndex.Unset]: ''
}
